
import Footer from "../Component/Footer";
import { Background } from "./Background";
import { Outlet } from "react-router-dom";
import './Pages.css'
function Registration() {
  return (
    <div>
      <Background />

      <Outlet />

      <Footer />
    </div>
  );
}

export default Registration;
